import type * as FormModelType from "@/components/features/hotel-notification-settings/model/type";

export const hotelNotificationSettingInputModelFactory = (
	id: string,
	hotelID: string,
): FormModelType.HotelNotificationSettingFormModel["InputModel"] =>
	({
		id,
		hotelID,
		reservationNotificationEmails: [],
		ecNotificationEmails: [],
		paymentNotificationEmails: [],
	}) satisfies FormModelType.HotelNotificationSettingFormModel["InputModel"];
